import api from "../../config/apiConfig";



const getPrivateStock = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  // // console.logF Service getindidualMutualFundInfo ::', 'Req data: ', data, 'Access Token :', accessToken);

  const response = await api.post("stocks/getAll/private", data, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const stockService = { getPrivateStock };
export default stockService;
